<section *ngIf="ticketPrice">
  <h4>{{ 'widget.reservation.redeemVoucher' | translate }}</h4>

  <div style="display: flex; align-items: flex-end; flex-wrap: wrap;">
    <div class="form-group" fxFlex="30" style="min-width: 250px;">
      <input
        class="form-control"
        placeholder="{{ 'widget.reservation.voucherCode' | translate }}"
        type="text"
        [(ngModel)]="enteredVoucher"
      />
    </div>
    <div class="form-group" style="margin-left: 10px;">
      <button
        style="height: 37px;"
        class="btn mat-raised-button mat-primary"
        (click)="checkVoucher()"
        [disabled]="!enteredVoucher || enteredVoucher.length < 3 || calculateFinalPrice() <= 0"
      >
        {{ 'widget.reservation.redeem' | translate }}
      </button>
    </div>
  </div>

  <div class="alert alert-danger mt-2" *ngIf="voucherError">
    {{ voucherError }}
  </div>

  <div class="applied-vouchers mt-3" *ngIf="appliedVouchers.length > 0">
    <div *ngFor="let voucher of appliedVouchers" class="voucher-tag">
      <span class="voucher-info">
        <strong>{{ voucher.code }}</strong> – {{ 'widget.reservation.voucherRedeemMsg1' | translate }}
        {{ voucher.code }}
        {{ 'widget.reservation.voucherRedeemMsg2' | translate }}
        {{ voucher.residualValue | currency: 'EUR' }}.
        {{ 'widget.reservation.voucherRedeemMsg3' | translate }}
        {{ voucher.voucherValue | currency: 'EUR' }}
        {{ 'widget.reservation.voucherRedeemMsg4' | translate }}.
        <br />
      </span>

      <button class="remove-btn" (click)="removeVoucher(voucher.code)" title="Remove voucher">
        ✕
      </button>
    </div>
  </div>
</section>
